var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    homes_near_street,
    property,
    streetname,
    is_mobile,
    homes_around_title,
    haven_cta_enabled,
    address_unavailable,
    haven_myhome_tracking_enabled,
    is_user_claimed_home,
    haven_property_cta,
    map
  } = options;
  let properties = homes_near_street.neighborhood_highlights;
  
__p+='\n\n\n  ';
 if (properties && properties.length) { 
__p+='\n  <h2 class="title-section">\n    <i class="ra ra-homes-around"></i>Homes Around '+
((__t=( streetname ))==null?'':__t)+
'\n  </h2>\n  <div class="component_bm-carousel">\n    <div class="rdc-carousel">\n      <div class="owl-carousel">\n        ';
 properties.forEach((property, listing_index) => { 
__p+='\n          '+
((__t=( JST["quick_view/templates/home-around/browse-module-card"]({property, listing_index, map}) ))==null?'':__t)+
'\n        ';
 }) 
__p+='\n      </div>\n      <div class="rdc-carousel-nav">\n        <div class="rdc-prev-set hide"><i class="ra ra-angle-left"></i></div>\n        <div class="rdc-next-set hide"><i class="ra ra-angle-right"></i></div>\n      </div>\n    </div>\n  </div>\n\n  ';
 }  else { 
__p+='\n    <div class="no-homes-around"> Sorry! No similar home available at this time!</div>\n  ';
 }
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/home-around/homes-around-carousel.jst.ejs